import { styled } from '@mui/material';

export const StyledLessonDescriptionHeaderWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '12px 12px 16px 16px',
});

export const StyledLessonDescriptionNextLesson = styled('div', {
	shouldForwardProp: (props) => props !== 'isTalented',
})<{ isTalented?: boolean }>(({ isTalented }) => ({
	padding: '16px 0',
	textAlign: 'end',
	marginTop: 'auto',
	...(!isTalented && {
		borderTop: '1px solid #CAC4D0',
	}),
}));
